const StorageKeys = {
  user: "user",
  access: "access_token",
  refresh: "refresh_token",
  expiration: "expiration",
  jobId:'job_id'
};
export default StorageKeys;
